import { Outlet } from "react-router-dom";
import { Stack } from "@/components/layout";
import { Text } from "@/components/typography";
import styles from "./AuthLayout.module.css";

/** Unauthenticated session layout — auth flow wires in K.1. */
export function AuthLayout() {
  return (
    <div className={styles.auth}>
      <div className={styles.panel}>
        <Stack gap={16}>
          <Text role="overline" color="muted">
            HUDDL HQ
          </Text>
          <Text role="h1" as="h1">
            Sign in
          </Text>
          <Outlet />
        </Stack>
      </div>
    </div>
  );
}
